/**
 * @generated SignedSource<<158c3b5064ca1c7d3f83ad6a87f39840>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnnounceOption_node$data = {
  readonly __typename: string;
  readonly id: string;
  readonly space?: {
    readonly __typename: "Space";
    readonly id: string;
    readonly modules: ReadonlyArray<{
      readonly canCreateAnnouncement?: {
        readonly value: boolean;
      };
    }>;
  };
  readonly " $fragmentType": "AnnounceOption_node";
};
export type AnnounceOption_node$key = {
  readonly " $data"?: AnnounceOption_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnnounceOption_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnnounceOption_node",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "space",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "modules",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AuthorizationResult",
                      "kind": "LinkedField",
                      "name": "canCreateAnnouncement",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "SpaceAnnouncementsModule",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Folder",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "247b27b3802bcc498a151713ec690429";

export default node;
